// @generated by protoc-gen-es v2.6.3 with parameter "keep_empty_files=true,target=js+dts"
// @generated from file proto/model/feature/activity/activity_search.proto (package carmen, syntax proto3)
/* eslint-disable */

import { enumDesc, fileDesc, messageDesc, tsEnum } from "@bufbuild/protobuf/codegenv2";
import { file_google_protobuf_duration } from "@bufbuild/protobuf/wkt";
import { file_proto_model_core_common } from "../../core/common_pb";
import { file_proto_model_core_date } from "../../core/date_pb";
import { file_proto_model_core_money } from "../../core/money_pb";
import { file_proto_model_core_place_types_culture } from "../../core/place_types/culture_pb";
import { file_proto_model_core_place_types_entertainment_and_recreation } from "../../core/place_types/entertainment_and_recreation_pb";
import { file_proto_model_core_place_types_sports } from "../../core/place_types/sports_pb";
import { file_proto_model_entity_geo } from "../../entity/geo_pb";
import { file_proto_model_entity_place } from "../../entity/place_pb";

/**
 * Describes the file proto/model/feature/activity/activity_search.proto.
 */
export const file_proto_model_feature_activity_activity_search = /*@__PURE__*/
  fileDesc("CjJwcm90by9tb2RlbC9mZWF0dXJlL2FjdGl2aXR5L2FjdGl2aXR5X3NlYXJjaC5wcm90bxIGY2FybWVuImMKFUFjdGl2aXR5RHVyYXRpb25SYW5nZRIWCgltaW5faG91cnMYASABKAJIAIgBARIWCgltYXhfaG91cnMYAiABKAJIAYgBAUIMCgpfbWluX2hvdXJzQgwKCl9tYXhfaG91cnMi5QcKDkFjdGl2aXR5U2VhcmNoEkgKE2VudGVydGFpbm1lbnRfdHlwZXMYASADKA4yKy5jYXJtZW4uRW50ZXJ0YWlubWVudEFuZFJlY3JlYXRpb25QbGFjZVR5cGUSLQoMc3BvcnRzX3R5cGVzGAIgAygOMhcuY2FybWVuLlNwb3J0c1BsYWNlVHlwZRIvCg1jdWx0dXJlX3R5cGVzGAMgAygOMhguY2FybWVuLkN1bHR1cmVQbGFjZVR5cGUSLwoMbWluX2R1cmF0aW9uGAQgASgLMhkuZ29vZ2xlLnByb3RvYnVmLkR1cmF0aW9uEi8KDG1heF9kdXJhdGlvbhgFIAEoCzIZLmdvb2dsZS5wcm90b2J1Zi5EdXJhdGlvbhIlCgpncm91cF9zaXplGAYgASgLMhEuY2FybWVuLlBhcnR5U2l6ZRIXCg9mYW1pbHlfZnJpZW5kbHkYByABKAgSKwoUbWF4X3ByaWNlX3Blcl9wZXJzb24YCCABKAsyDS5jYXJtZW4uTW9uZXkSJgoPbWF4X3RvdGFsX3ByaWNlGAkgASgLMg0uY2FybWVuLk1vbmV5EicKC3ByaWNlX2xldmVsGAogASgOMhIuY2FybWVuLlByaWNlTGV2ZWwSLQoNc2VhcmNoX3JlZ2lvbhgLIAEoCzIWLmNhcm1lbi5DaXJjdWxhclJlZ2lvbhIfCghsb2NhdGlvbhgMIAEoCzINLmNhcm1lbi5QbGFjZRIpCg5hY3Rpdml0eV9kYXRlcxgNIAEoCzIRLmNhcm1lbi5EYXRlUmFuZ2USLwoScmVxdWlyZWRfYW1lbml0aWVzGA4gAygOMhMuY2FybWVuLkNvcmVBbWVuaXR5Eh0KFXdoZWVsY2hhaXJfYWNjZXNzaWJsZRgPIAEoCBIaChJoZWFyaW5nX2FjY2Vzc2libGUYECABKAgSGQoRdmlzdWFsX2FjY2Vzc2libGUYESABKAgSFwoPaW5zdGFudF9ib29raW5nGBIgASgIEhkKEWZyZWVfY2FuY2VsbGF0aW9uGBMgASgIEhgKEG91dGRvb3JfYWN0aXZpdHkYFCABKAgSFQoNYXZhaWxhYmxlX25vdxgVIAEoCBISCgptaW5fcmF0aW5nGBYgASgBEhQKDHNlYXJjaF9xdWVyeRgXIAEoCRIsCg5hY3Rpdml0eV90eXBlcxgYIAMoDjIULmNhcm1lbi5BY3Rpdml0eVR5cGUSNQoRb3B0aW1pemF0aW9uX2dvYWwYGSABKA4yGi5jYXJtZW4uQWN0aXZpdHlTZWFyY2hHb2FsEhMKC21heF9yZXN1bHRzGBogASgFKuYBCgxBY3Rpdml0eVR5cGUSHQoZQUNUSVZJVFlfVFlQRV9VTlNQRUNJRklFRBAAEhcKE0FDVElWSVRZX1RZUEVfVE9VUlMQARIcChhBQ1RJVklUWV9UWVBFX0FDVElWSVRJRVMQAhIbChdBQ1RJVklUWV9UWVBFX0xBTkRNQVJLUxADEh8KG0FDVElWSVRZX1RZUEVfRU5URVJUQUlOTUVOVBAEEhwKGEFDVElWSVRZX1RZUEVfRk9PRF9EUklOSxAFEiQKIEFDVElWSVRZX1RZUEVfVFJBTlNGRVJTX1NFUlZJQ0VTEAYqzwEKEkFjdGl2aXR5U2VhcmNoR29hbBIkCiBBQ1RJVklUWV9TRUFSQ0hfR09BTF9VTlNQRUNJRklFRBAAEiYKIkFDVElWSVRZX1NFQVJDSF9HT0FMX0hJR0hFU1RfUkFURUQQARIhCh1BQ1RJVklUWV9TRUFSQ0hfR09BTF9DSEVBUEVTVBACEiUKIUFDVElWSVRZX1NFQVJDSF9HT0FMX01PU1RfUE9QVUxBUhADEiEKHUFDVElWSVRZX1NFQVJDSF9HT0FMX0ZMRVhJQkxFEARCOVo3Z2l0aHViLmNvbS95dW5hY2FiYS9jYXJtZW4vcHJvdG8vbW9kZWwvZmVhdHVyZS9hY3Rpdml0eWIGcHJvdG8z", [file_google_protobuf_duration, file_proto_model_core_common, file_proto_model_core_date, file_proto_model_core_money, file_proto_model_core_place_types_culture, file_proto_model_core_place_types_entertainment_and_recreation, file_proto_model_core_place_types_sports, file_proto_model_entity_geo, file_proto_model_entity_place]);

/**
 * Describes the message carmen.ActivityDurationRange.
 * Use `create(ActivityDurationRangeSchema)` to create a new message.
 */
export const ActivityDurationRangeSchema = /*@__PURE__*/
  messageDesc(file_proto_model_feature_activity_activity_search, 0);

/**
 * Describes the message carmen.ActivitySearch.
 * Use `create(ActivitySearchSchema)` to create a new message.
 */
export const ActivitySearchSchema = /*@__PURE__*/
  messageDesc(file_proto_model_feature_activity_activity_search, 1);

/**
 * Describes the enum carmen.ActivityType.
 */
export const ActivityTypeSchema = /*@__PURE__*/
  enumDesc(file_proto_model_feature_activity_activity_search, 0);

/**
 * Types of activities/attractions.
 *
 * @generated from enum carmen.ActivityType
 */
export const ActivityType = /*@__PURE__*/
  tsEnum(ActivityTypeSchema);

/**
 * Describes the enum carmen.ActivitySearchGoal.
 */
export const ActivitySearchGoalSchema = /*@__PURE__*/
  enumDesc(file_proto_model_feature_activity_activity_search, 1);

/**
 * Search optimization goals for activities.
 *
 * @generated from enum carmen.ActivitySearchGoal
 */
export const ActivitySearchGoal = /*@__PURE__*/
  tsEnum(ActivitySearchGoalSchema);

